// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__yKOLv","title":"styles_title__3d97x"};